<template>
  <div class="header__background">
    <picture>
      <source
        srcset="/images/toolbox-header-image-mobile.jpg"
        fetchpriority="high"
        media="(max-width: 480px)"
      />
      <source
        srcset="/images/toolbox-header-image-tablet.jpg"
        fetchpriority="high"
        media="(max-width: 1025px)"
      />
      <source
        srcset="/images/toolbox-header-image-desktop.jpg"
        fetchpriority="high"
        media="(max-width: 1440px)"
      />
      <img
        width="640"
        height="360"
        fetchpriority="high"
        src="/images/toolbox-header-image-lg-desktop.jpg"
        alt="Product Focus Toolbox Image"
      />
    </picture>
  </div>
</template>

<style lang="scss" scoped>
  .header__background {
    position: absolute;
    top: 40px;
    left: 0;
    width: 100%;
    z-index: -1;

    img {
      object-fit: cover;
      width: 100%;
    }
  }
</style>
